import React from "react";
import { CloseIcon } from "../../../assets/icons";
import FileDisplay from "../../../utils/FileDisplay";
import NuDateFormat from "../../../utils/NuDate";
import { ViewLabelwithDataBg } from "../../../components/View/ViewLabelwithData";

function ViewMOM({ visible, onClose, data }) {
  if (!visible) return null;

  return (
    <div
      id="modal"
      className="bg-black bg-opacity-30 fixed inset-0 backdrop-blur-sm 
  flex justify-center items-center z-10"
    >
      <div className="bg-white p-2 rounded w-10/12 max-h-[calc(100vh-80px)] overflow-hidden">
        <div className="flex items-start justify-between px-5 py-2  rounded-t">
          <h3 className="text-base 2xl:text-xl capitalize font-semibold">
          {data?.heading + " View" || "CISO / MRM Meeting MoM View"}
          </h3>
          <span
            className="h-6 w-6 text-2xl block cursor-pointer"
            onClick={onClose}
          >
            <CloseIcon />
          </span>
        </div>
        <div className="overflow-y-auto max-h-[calc(100vh-140px)]">
          <div>
            <ViewLabelwithDataBg title="Heading" value={data?.heading || "-"} />
            <ViewLabelwithDataBg title="Group" value={data?.group_data || "-"} />
            <ViewLabelwithDataBg title="Meeting Type" value={data?.type_of_meeting || "-"} />
            <ViewLabelwithDataBg title="Date" value={NuDateFormat({
                  value: data?.mom_date,
                  format: "DD-MMM-yyyy",
                }) || "-"} />
            <ViewLabelwithDataBg title="Start Time" value={data?.start_time || "-"} />
            <ViewLabelwithDataBg title="End Time" value={data?.end_time || "-"} />
            <ViewLabelwithDataBg title="Regrets" value={data?.regrets || "-"} />
            <ViewLabelwithDataBg title="Venue" value={data?.venue || "-"} />
            <ViewLabelwithDataBg title="Chaired By" value={data?.chaired_by || "-"} />
            <ViewLabelwithDataBg title="Minute By" value={data?.minute_by || "-"} />
            <ViewLabelwithDataBg title="Status" value={data?.status || "-"} />
            <div className="my-3 text-left">
              <p className="text-sm text-[#1D1818] font-semibold mb-1 pl-8">
              Artefact
              </p>
              <div className=" w-full flex flex-wrap">
                {data?.attachments &&
                  data?.attachments.map((i) => {
                    return (
                      <div className=" m-1">
                        <FileDisplay data={i} view={true} height={"45px"} width={"45px"} />
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewMOM;
